import { IBlock } from "@Front/Components/DesignSystem/SearchBlockList/BlockList/Block";
import { useRouter } from "next/router";
import DefaultDashboardWithList, { IPropsDashboardWithList, SIDEBAR_LIST_COMPACT_SEARCH } from "../DefaultDashboardWithList";
import { useMemo } from "react";
import { Routes, buildRoute } from "@Front/Config/Routes";
import { buildLegalDashboardBlocks } from "./defaultLegalDashboardBlocksHelpers";

export { ELegalOptions } from "./defaultLegalDashboardTypes";

type IProps = IPropsDashboardWithList;

export default function DefaultLegalDashboard(props: IProps): React.JSX.Element {
	const router = useRouter();
	const { legalUid } = router.query;

	const onSelectedBlock = (block: IBlock): void => {
		void router.push(buildRoute(Routes.pages.Legal.LegalInformations, { legalUid: block.id }));
	};

	const blocks = useMemo(() => buildLegalDashboardBlocks(legalUid), [legalUid]);

	return (
		<DefaultDashboardWithList
			{...props}
			sidebarCompactSearch={SIDEBAR_LIST_COMPACT_SEARCH}
			onSelectedBlock={onSelectedBlock}
			blocks={blocks}
			noPadding
		/>
	);
}
